import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Droppable, Draggable, DragDropContext } from "react-beautiful-dnd";

import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../../css/course-catelog.css";
import OpenWithIcon from '@material-ui/icons/OpenWith';
import Latex from "./Latex";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};
const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  boxShadow: "5px 5px 25px 0 rgb(46 61 73 / 20%)",
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? "lightgreen" : "white",

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#ebf1f8" : "#ebf1f8",
  padding: grid,
});

const getItems = (count, offset = 0) =>
  Array.from({ length: count }, (v, k) => k).map((k) => ({
    id: `item-${k + offset}`,
    content: `item ${k + offset}`,
  }));

class Dragndrop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newshufflearray: props.newshufflearray,
      assignmentid: props.assignmentid,
      assignmentOfferingid: props.assignmentOfferingid,
      mtfQuetionlist: props.mtfQuetionlist,
      loading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.newshufflearray !== this.props.newshufflearray) {
      this.setState({
        newshufflearray: this.props.newshufflearray,
      });
    }
  }

  state = {
    newshufflearray: getItems(),
    selected: getItems(),
  };

  id2List = {
    droppable: "newshufflearray",
    droppable2: "selected",
  };

  getList = (id) => this.state[this.id2List[id]];

  onDragEnd = (result) => {
    // console.log("a" + result);
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    // console.log("source.droppableId " + source.droppableId);
    // console.log("destination.droppableId " + destination.droppableId);
    if (source.droppableId === destination.droppableId) {
      const newshufflearray = reorder(
        this.getList(source.droppableId),
        source.index,
        destination.index
      );
      // console.log("items " + newshufflearray);
      let state = { newshufflearray };
      // console.log("state " + state);
      if (source.droppableId === "droppable2") {
        state = { selected: newshufflearray };
      }

      this.setState(state);
      // console.log("thisstate " + this.state);
    } else {
      const result = move(
        this.getList(source.droppableId),
        this.getList(destination.droppableId),
        source,
        destination
      );

      this.setState({
        items: result.droppable,
        selected: result.droppable2,
      });
    }
  };

  handleSubmit(
    e,
    assignmentid,
    assignmentOfferingid,
    shuffledPosts,
    mtfQuetionlist
  ) {
    e.preventDefault();
    this.savemtp(
      assignmentid,
      assignmentOfferingid,
      shuffledPosts,
      mtfQuetionlist
    );
  }

  async savemtp(
    assignmentid,
    assignmentOfferingid,
    shuffledPosts,
    mtfQuetionlist
  ) {
    this.setState({  loading: true});
   
    var formData = new FormData();

    formData.append("ass", assignmentid);
      mtfQuetionlist.map((itemn, indexitemn) =>
        // formData.append("question", itemn.qid)
        formData.append(itemn.qid,shuffledPosts[indexitemn]?.aid)
      );
      // mtfQuetionlist.map((itemn, indexitemn) =>
      //   // formData.append("question", itemn.qid)
      //   console.log(itemn.qid+"--"+shuffledPosts[indexitemn]?.aid)
      // );
      shuffledPosts.map((itemn, indexitemn) =>
        formData.append("answer", itemn.aid)
      );

    axios
      .post("LearnerAssignment/saveMatchthePairAssAnswer", formData)

      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            loading: false,
            shuffledPosts: res.data.savedmtpanslist,
            issavedata: true,
          });

          // console.log(this.state.shuffledPosts);
          toast.success(res.data.msg);
        } else {
          toast.error("Something went wrong");
        }
      }).catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  render() {
    return (
      <div>

        <div>
          <DragDropContext  onDragEnd={this.onDragEnd}>
            <Droppable  droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                 
                >
                  {this.state.newshufflearray.map((iteml, index) => (
                    <Draggable
                      key={iteml.aid}
                      draggableId={iteml.fanswer}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                         <OpenWithIcon className="icon-drag" /> <Latex>{iteml.fanswer} </Latex> 
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <br />
       

        <div className="row">
              <div className="col-lg-12 text-center">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={this.state.loading}
                  onClick={(e) =>
                    this.handleSubmit(
                      e,
                      this.state.assignmentid,
                      this.state.assignmentOfferingid,
                      this.state.newshufflearray,
                      this.state.mtfQuetionlist
                    )
                  }
                >
                  Submit
                </Button>

                {this.state.loading === true ? (
                  <CircularProgress
                    size={24}
                    color="green"
                    className="buttonProgress1"
                  />
                ) : (
                  ""
                )}
              </div>
            </div>


      </div>
    );
  }
}

export default Dragndrop;
